export enum ConversionType {
    ChallengeBriefingPageView = 0,
    UploadPitchPageView = 1,
    QuestionsPageView = 2,
    ChallengeBriefingReadMoreClick = 3,
    FollowChallengeButtonClick = 4,
    FollowChallengeSuccess = 5,
    SubmissionConceptCreate = 6,
    SubmissionSubmit = 7,
    SubmissionEdit = 8,
    LoginFromChallenge = 9,
    SignUpForChallenge = 10,
    SubmissionSubmitButtonClick = 11,
    SubmissionSubmitStart = 12,
    SubmissionSubmitError = 13,
    SubmissionSubmitConfirm = 14,
    ChallengeMeetupFormPageView = 15,
    ChallengeMeetupFormAddItemSuccess = 16,
}